import type { Workspace } from "@salon-pos/shared";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";

const IS_NATIVE = import.meta.env.VITE_CLIENT === "native";

/**
 * Subscription dunning banner. Shown in every workspace (the POS must know it is read-only), but the link to
 * "Plan & billing" exists ONLY in the owner web portal — never in the native app or the checkout/employee workspaces.
 */
export function BillingBanner({ ws }: { ws: Workspace }) {
  const { me } = useAuth();
  const { t, locale } = useI18n();
  const b = me?.billing;
  if (!me || !b || (b.access === "full" && b.phase !== "grace")) return null;
  // (Task iOS, App Store 3.1.1) the store app never asks to pay or update a card: grace is silent, blocked states say "contact the owner"
  if (IS_NATIVE) {
    if (b.access === "full") return null;
    return <div className="banner banner-error" role="alert"><span>{t(b.access === "suspended" ? "native.banner.suspended" : "native.banner.readOnly")}</span></div>;
  }
  const date = (s: string | null) => (s ? new Date(s).toLocaleDateString(locale === "zh" ? "zh-CN" : locale) : "");
  const canFix = ws === "owner" && !IS_NATIVE && !!me.permissions["billing.manage"];
  const text = b.access === "suspended" ? t("w7.banner.suspended") : b.access === "read_only" ? t("w7.banner.readOnly") : t("w7.banner.grace", { date: date(b.graceEndsAt) });
  return (
    <div className={"banner " + (b.access === "full" ? "banner-warn" : "banner-error")} role="alert">
      <span>{text}</span>
      {!IS_NATIVE && canFix ? <Link className="btn btn-link" to={IS_NATIVE ? "/" : "/owner/settings?tab=plan"}>{t("w7.banner.fix")}</Link> : <span className="small">{t("w7.banner.askOwner")}</span>}
    </div>
  );
}
